import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#F0F0F0",
  d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#D80027",
  d: "M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#F0F0F0",
  d: "M7.304 6.261a3.65 3.65 0 0 1 2.87-3.567 3.652 3.652 0 1 0 0 7.135 3.65 3.65 0 0 1-2.87-3.568M12 2.87l.258.797h.839l-.678.493.259.797-.679-.493-.678.493.26-.797-.679-.493h.839z"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#F0F0F0",
  d: "m9.964 4.435.26.797h.838l-.678.493.258.797-.678-.493-.678.493.26-.797-.679-.493h.838zM14.03 4.435l.26.797h.838l-.678.493.259.797-.678-.493-.678.493.259-.797-.678-.493h.838zM13.25 6.783l.258.798h.839l-.678.492.259.797-.679-.492-.678.492.26-.797-.679-.492h.838zM10.75 6.783l.258.798h.839l-.678.492.259.797-.679-.492-.678.492.26-.797-.679-.492h.839z"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }